import "./subway.scss";

import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { PopoverBody } from "reactstrap";

import { withContainerContext } from "../../components/container/ContainerContext";
import FormSegmentControl from "../../components/form/FormSegmentControl";
import Icon from "../../components/interface/Icon";
import FocusedPopover from "../../components/popover/FocusedPopover";
import { withXScrollPositionContext } from "../../components/scrollable/ScrollPositionContext";
import TreeListView from "../../components/treeList/TreeListView";
import subwayDisplayOptions from "../../constants/subwayDisplayOptions";
import { immutableRecords, PropTypeShapes } from "../../types";

const segmentOptions = [
  {
    label: "Subway",
    value: subwayDisplayOptions.SUBWAY
  },
  {
    label: "Separated",
    value: subwayDisplayOptions.SPLIT
  }
];

class SubwayHeaderView extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      popoverOpen: false
    };
    this.toggleMenu = this.toggleMenu.bind(this);

    this._liveScrollListeners = {
      onLiveScrollStart: this.onLiveScrollStart.bind(this),
      onLiveScrollUpdate: this.onLiveScrollUpdate.bind(this),
      onLiveScrollStop: this.onLiveScrollStop.bind(this)
    };

    this.getStickyStyle = this.getStickyStyle.bind(this);
    this.applyStickyStyle = this.applyStickyStyle.bind(this);

    this._stickyDomNode = null;
    this._horizontalScrollerActive = false;
    this._liveLeft = 0;
  }

  componentDidMount() {
    this.props.xScrollActions.registerForLiveUpdates(this._liveScrollListeners);
  }

  componentWillUnmount() {
    this.props.xScrollActions.unregisterForLiveUpdates(this._liveScrollListeners);
  }

  onLiveScrollStart(horizontalScroller) {
    if (horizontalScroller) {
      this._horizontalScrollerActive = true;
      this.applyStickyStyle();
    }
  }

  onLiveScrollUpdate(scrollLeft) {
    if (!isNil(scrollLeft) && scrollLeft !== this._liveLeft) {
      this._liveLeft = scrollLeft;
    }
  }

  onLiveScrollStop(horizontalScroller) {
    if (horizontalScroller) {
      this._horizontalScrollerActive = false;
      this.applyStickyStyle();
    }
  }

  applyStickyStyle() {
    const style = this.getStickyStyle();
    this._stickyDomNode.style.left = style.left;
    this._stickyDomNode.style.top = style.top;
    this._stickyDomNode.style.overflow = style.overflow;
    this._stickyDomNode.style.position = style.position;
  }

  getStickyStyle() {
    let left = `${this._liveLeft}px`;
    let top = "0px";
    let overflow = null;
    let position = "absolute";
    const maxWidth = `${this.props.containerRect.width}px`;
    if (this._horizontalScrollerActive) {
      left = `${this.props.containerRect.left}px`;
      top = `${this.props.containerRect.top}px`;
      position = "fixed";
      overflow = "hidden";
    }

    return {
      left,
      top,
      overflow,
      position,
      maxWidth
    };
  }

  toggleMenu() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  renderMenu() {
    const onAddThread = typeId => {
      //#!if readonly !== true
// this.toggleMenu();
// this.props.onAddThread(typeId, this.props.viewId);
      //#!endif
    };

    return (
      <div className="subwaySettingsPopoverContent">
        <TreeListView groups={this.props.allowedThreads} onChange={this.props.onThreadToggle} onAdd={onAddThread} />
      </div>
    );
  }

  renderSelectThreadsButton() {
    const settingsId = `subwaySelector-${this.props.viewId}`;
    const style = this.getStickyStyle();
    const buttonLabel = "Choose Tracks";

    return (
      <div key="subwaySettings" className="subwaySettingsBar" style={style} ref={node => (this._stickyDomNode = node)}>
        <div className="subwayThreadSelectButton splitBtn alwaysDropdown" onClick={this.toggleMenu} id={settingsId}>
          <div className="label">
            <span>{buttonLabel}</span>
            <div className={`toggle`}>
              <Icon icon="downArrow" color="iconMono" />
            </div>
          </div>
          <Fragment>
            {this.state.popoverOpen ? (
              <FocusedPopover
                className="subwayPopover"
                placement="bottom-start"
                hideArrow={false}
                isOpen={this.state.popoverOpen}
                target={settingsId}
                toggle={this.toggleMenu}
                modifiers={{
                  shift: {
                    enabled: true
                  }
                }}
                trigger="legacy"
              >
                <PopoverBody onClick={e => e.stopPropagation()}>{this.renderMenu()}</PopoverBody>
              </FocusedPopover>
            ) : null}
          </Fragment>
        </div>
        {/* #!if mobile === true */}
{/* <FormSegmentControl*/}
{/* options={segmentOptions}*/}
{/* value={this.props.data.display}*/}
{/* onChange={this.props.onChangeDisplayOption}*/}
{/* style={{ flex: "1" }}*/}
{/* />*/}
        {/* #!endif */}
      </div>
    );
  }

  renderTicks() {
    return (
      <div key="subwayTicks" className="subwayTickBar">
        {this.props.data.ticks
          .map(tick => {
            return (
              <div key={tick.x} className="subwayTick" style={{ left: `${tick.x}px` }}>
                {tick.label}
              </div>
            );
          })
          .toArray()}
      </div>
    );
  }

  render() {
    return (
      <div className="subwayHeaderView">
        {this.renderSelectThreadsButton()}
        {this.renderTicks()}
      </div>
    );
  }
}

SubwayHeaderView.propTypes = {
  isActiveView: PropTypes.bool.isRequired,
  fontSize: PropTypes.number.isRequired,
  viewId: PropTypes.string.isRequired,
  data: PropTypeShapes.subwayData.isRequired,
  allowedThreads: PropTypeShapes.listOptionGroupList.isRequired,
  visibleItemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  selectedItemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  onNodeDrop: PropTypes.func.isRequired,
  onThreadToggle: PropTypes.func.isRequired,
  onAddThread: PropTypes.func.isRequired,
  onAddNode: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onSelectItems: PropTypes.func.isRequired,
  onChangeDisplayOption: PropTypes.func.isRequired,
  subwayViewSettings: PropTypeShapes.subwayViewSettings.isRequired,

  requestCanDropItems: PropTypes.func.isRequired,

  // From withScrollPositionContext
  xScrollPosition: PropTypes.instanceOf(immutableRecords.ScrollPositionRecord).isRequired,
  xScrollActions: PropTypeShapes.scrollActions.isRequired,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default withContainerContext(withXScrollPositionContext(SubwayHeaderView));
